"use client";

import { useEffect, useRef } from "react";
import QuickNavLinks from "./QuickNavLinks";

export default function CommercialHeader() {
    const ref = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const els = ref?.current?.querySelectorAll(".reveal");
        if (!els) return;
        const observer = new IntersectionObserver(
            (entries) =>
                entries.forEach((e) => {
                    if (e.isIntersecting) {
                        e.target.classList.add("visible");
                        observer.unobserve(e.target);
                    }
                }),
            { threshold: 0.1 }
        );
        els?.forEach((el) => observer?.observe(el));
        return () => observer?.disconnect();
    }, []);

    return (
        <section
            ref={ref}
            className="section-navy"
            style={{ paddingTop: "140px", paddingBottom: "80px" }}
            aria-label="Commercial page header"
        >
            <div
                className="px-6 lg:px-12 text-center"
                style={{ maxWidth: "1280px", margin: "0 auto" }}
            >
                <div
                    className="flex items-center justify-center gap-3 mb-8 reveal"
                    style={{ paddingTop: "8px" }}
                >
                    <span
                        className="divider-red"
                        style={{ width: "32px" }}
                        aria-hidden="true"
                    />
                    <span className="type-subheading">Commercial</span>
                </div>
                <h1
                    className="reveal reveal-delay-1"
                    style={{
                        fontFamily: "var(--font-serif)",
                        fontSize: "clamp(2.5rem, 5vw, 4rem)",
                        fontWeight: 400,
                        color: "var(--color-white)",
                        lineHeight: 1.05,
                        letterSpacing: "-0.02em",
                        maxWidth: "700px",
                        margin: "0 auto",
                    }}
                >
                    Bankable terms for serious counterparties.
                </h1>
                <p
                    className="reveal reveal-delay-2"
                    style={{
                        fontFamily: "var(--font-sans)",
                        fontSize: "1.0625rem",
                        color: "rgba(255,255,255,0.55)",
                        lineHeight: "1.7",
                        maxWidth: "520px",
                        marginTop: "20px",
                        margin: "20px auto 0",
                    }}
                >
                    Transparent offtake structures, market-referenced pricing, and
                    clear risk allocation — designed for procurement and legal teams
                    who require certainty before committing.
                </p>
            </div>
            <QuickNavLinks />
        </section>
    );
}
